import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { AuthProvider } from './contexts/AuthContext';
import AuthPage from './pages/AuthPage';
import HomePage from './pages/HomePage';
import Footer from './components/navigation/Footer';
import SettingsPage from './pages/SettingsPage';
import EventListPage from './pages/EventListPage';
import EventDetailPage from './pages/EventDetailPage';
import MyEventsPage from './pages/MyEventsPage';
import ResetPasswordPage from './pages/ResetPasswordPage';
// import ImportOpenAgendaPage from './pages/admin/ImportOpenAgendaPage';
// import ImportDataTourismePage from './pages/admin/ImportDataTourismePage';
//import ImportDataTourismeDataGouv from './pages/admin/ImportDataTourismeDataGouv';
import ProfileEditPage from './pages/ProfileEditPage';
import TestIaPage from './pages/admin/TestIaPage';
import ImportCommunePage from './pages/admin/ImportCommunePage';
import JobsManagementPage from './pages/admin/JobsManagementPage';
import GeoEvent from './pages/admin/GeoEvent';
import CreateEventPage from './pages/CreateEventPage';
import CreditRechargePage from './pages/CreditRechargePage';
import EventApprovalPage from './pages/admin/EventApprovalPage';
import EditEventPage from './pages/EditEventPage';
import TermsPage from './pages/TermsPage';
import LegalNoticePage from './pages/LegalNoticePage';
import ContactPage from './pages/ContactPage';
import CreditsPage from './pages/CreditsPage';
import VisitsPage from './pages/admin/VisitsPage';
import ReportsPage from './pages/admin/ReportsPage';
import { usePageTracking } from './hooks/usePageTracking';
import ScrollToTop from './components/ScrollToTop';
import UsersPage from './pages/admin/UsersPage';
import CategoriesManagementPage from './pages/admin/CategoriesManagementPage';
import EventStatsPage from './pages/EventStatsPage';
import ImportWebsitePage from './pages/admin/ImportWebsitePage';
import GeneralSettingsPage from './pages/admin/GeneralSettingsPage';
import IconsPreviewPage from './pages/admin/IconsPreviewPage';
import InterestsMapPage from './pages/admin/InterestsMapPage';
import OpenAIBatchesPage from './pages/admin/OpenAIBatchesPage';
import PrivacyPolicyPage from './pages/PrivacyPolicyPage';
import UpdateCommunePage from './pages/admin/UpdateCommunePage';
import SocialPublishPage from './pages/admin/SocialPublishPage';
import InvoicesPage from './pages/InvoicesPage';
import MalakoffWeekendPage from './pages/MalakoffWeekendPage';


/**
 * Composant interne qui utilise le tracking
 * Doit être à l'intérieur d'AuthProvider
 */
function AppContent() {
  // Active le tracking des pages
  usePageTracking('Maploop');

  return (
    <div className="flex flex-col h-[100dvh] overflow-hidden">
      <ScrollToTop />
      <div className="flex-1 overflow-y-auto">
        {/* <Header className="fixed top-0 left-0 right-0 z-30" /> */}

      {/* espace “placeholder” pour le header dans le flux normal */}
      {/* <div className="h-16 shrink-0" /> */}

        <Routes>
          {/* Route racine - Redirection vers la page de carte */}
          <Route path="/" element={<HomePage />} />
          <Route path="/malakoff" element={<MalakoffWeekendPage />} />
          
          {/* Routes principales de l'application */}
          <Route path="/map" element={<HomePage />} />
          <Route path="/list" element={<EventListPage />} />
          <Route path="/event/:eventId" element={<EventDetailPage />} />
          <Route path="/my-events" element={<MyEventsPage />} />
          <Route path="/create-event" element={<CreateEventPage />} />
          <Route path="/edit-event/:eventId" element={<EditEventPage />} />
          <Route path="/event/:eventId/stats" element={<EventStatsPage />} />
          
          {/* Route des paramètres */}
          <Route path="/settings" element={<SettingsPage />} />
          <Route path="/settings/profile" element={<ProfileEditPage />} />
          <Route path="/settings/credits" element={<CreditRechargePage />} />
          <Route path="/settings/invoices" element={<InvoicesPage />} />
          <Route path="/settings/terms" element={<TermsPage />} />
          <Route path="/settings/legal" element={<LegalNoticePage />} />
          <Route path="/settings/contact" element={<ContactPage />} />
          <Route path="/settings/credits-page" element={<CreditsPage />} />
          <Route path="/settings/privacy" element={<PrivacyPolicyPage />} />

          {/* Routes d'authentification */}
          <Route path="/auth" element={<Navigate to="/auth/login" replace />} />
          
          {/* Route spécifique de réinitialisation de mot de passe - DOIT être avant la route générique */}
          <Route path="/auth/reset-password" element={<ResetPasswordPage />} />
          
          {/* Route générique d'authentification avec paramètre */}
          <Route path="/auth/:mode" element={<AuthPage />} />
          
          {/* Routes d'administration */}
          {/* <Route path="/admin/import-datatourisme-datagouv" element={<ImportDataTourismeDataGouv />} /> */}
          <Route path="/admin/test-ia" element={<TestIaPage />} />
          <Route path="/admin/icons-preview" element={<IconsPreviewPage />} />
          <Route path="/admin/import-commune" element={<ImportCommunePage />} />
          <Route path="/admin/jobs-management" element={<JobsManagementPage />} />
          <Route path="/admin/geo-event" element={<GeoEvent />} />
          <Route path="/admin/event-approval" element={<EventApprovalPage />} />
          <Route path="/admin/edit-event/:eventId" element={<EditEventPage />} />
          <Route path="/admin/visits" element={<VisitsPage />} />
          <Route path="/admin/reports" element={<ReportsPage />} />
          <Route path="/admin/users" element={<UsersPage />} />
          <Route path="/admin/categories" element={<CategoriesManagementPage />} />
          <Route path="/admin/import-website" element={<ImportWebsitePage />} />
          <Route path="/admin/general-settings" element={<GeneralSettingsPage />} />
          <Route path="/admin/interests-map" element={<InterestsMapPage />} />
          <Route path="/admin/openai-batches" element={<OpenAIBatchesPage />} />
          <Route path="/admin/update-commune" element={<UpdateCommunePage />} />
          <Route path="/admin/social-publish" element={<SocialPublishPage />} />
          
          {/* Redirection pour compatibilité */}
          <Route path="/admin/jobs" element={<Navigate to="/admin/jobs-management" replace />} />
          
          {/* Redirection pour les routes inconnues */}
          <Route path="*" element={<Navigate to="/map" replace />} />
        </Routes>
      </div>
      
    <div className="h-13 shrink-0" />

      {/* Footer de navigation */}
      <Footer className="shrink-0 fixed left-0 right-0 z-30" />
      
      {/* Configuration du toast pour les notifications */}
      {/* <Toaster
        position="top-right"
        toastOptions={{
          duration: 5000,
          style: {
            background: '#363636',
            color: '#fff',
          },
          success: {
            style: {
              background: 'rgb(40, 148, 216)',
            },
          },
          error: {
            style: {
              background: '#e74c3c',
            },
          },
        }}
      /> */}
    </div>
  );
}

/**
 * Composant principal de l'application Maploop
 * Utilise Suspense pour les chargements asynchrones (i18next)
 */
function App() {
  return (
    <AuthProvider>
      <AppContent />
    </AuthProvider>
  );
}

export default App;
